module.exports = __webpack_public_path__ + "static/img/yinliang.75e8b72.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/blue/yinliang.png
// module id = lLnF
// module chunks = 24